import { useStorageKeys } from '../../storage';
import { useCurrentAccount } from './useCurrentAccount';
import { useQuery } from '@tanstack/react-query';
import { useGrippContext } from '../../grippContext';
import { Workspace } from '../../workspace/domain';

export type useCurrentWorkspaceHook = (storageOnly?: boolean) => any;

export const useCurrentWorkspace = (storageOnly?: boolean) => {
  const { storageHandler } = useGrippContext();
  const storageKeys = useStorageKeys();
  const { account, isFetching } = useCurrentAccount();

  // The impersonated workspace is JSON.stringify'd in useImpersonateWorkspace
  // before being stored, so parsing here yields a full Workspace object.
  const { data } = useQuery<Workspace | null>({
    staleTime: Infinity,
    queryKey: ['currentWorkspace'],
    queryFn: async () => {
      const item = await storageHandler.getItem(storageKeys.workspace);
      return item ? JSON.parse(item as string) : null;
    },
  });

  if (data) {
    return data;
  }
  if (account) {
    if (isFetching || (account.isGlobalAdmin() && storageOnly)) {
      return null;
    }
    return account.workspace;
  }
  return undefined;
};

/*
  for queries:
    - if local storage is set, use that
    - else,
        if global admin, do nothing
          else, use account workspace
*/
